// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SettingTwoToneSvg from "@ant-design/icons-svg/es/asn/SettingTwoTone";
import AntdIcon from '../components/AntdIcon';

var SettingTwoTone = function SettingTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SettingTwoToneSvg
  }));
};

SettingTwoTone.displayName = 'SettingTwoTone';
export default React.forwardRef(SettingTwoTone);